import { Switch } from 'antd';
import Text from 'components/Text';
import styled from 'styled-components';
import { ModalRepeat, useModalRepeatRef } from './ModalRepeat';
type Props = {
  value?: number;
  onChange?: (value?: number) => void;
};
const Repeat = ({ value, onChange }: Props) => {
  const ref = useModalRepeatRef();
  const handleSubmit = (value: number) => {
    onChange?.(value);
  };

  return (
    <>
      <Container>
        <Switch style={{ zoom: 1.3 }} checked={!!value} title='Repeat' onClick={() => ref?.current?.open(value || 0)} />
        <Text variant='H7' color='text_3' className='text-overflow'>Repeat</Text>
      </Container>
      <ModalRepeat ref={ref} onSubmit={handleSubmit} />
    </>
  );
};

export default Repeat;

const Container = styled.label`
display: flex;
align-items: center;
gap: 4px;
`;